exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.validation-error[data-v-51fc1e8c] {\n  font-style: italic;\n  color: red;\n  display: block;\n  text-align: right;\n}\n", ""]);

// exports
